export default [
  {
    path: '/app/announcements',
    name: 'Announcements',
    component: () => import('@/views/Announcements/Index.vue'),
    meta: {
      pageTitle: 'Duyurular',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_ANNOUNCEMENTS',
      action: 'read',
    },
  },
  {
    path: '/app/announcements/add',
    name: 'AnnouncementAdd',
    component: () => import('@/views/Announcements/Add.vue'),
    meta: {
      pageTitle: 'Duyurular',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/announcements',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_ANNOUNCEMENTS',
      action: 'read',
    },
  },
  {
    path: '/app/announcements/edit/:id',
    name: 'AnnouncementEdit',
    component: () => import('@/views/Announcements/Edit.vue'),
    meta: {
      pageTitle: 'Duyurular',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/announcements',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_ANNOUNCEMENTS',
      action: 'read',
    },
  },
]
